import type { BroadcastService } from '@app/services/BroadcastService'

import { createThunk } from '@app/store/thunk'

export function getBroadcastService() {
  return createThunk((_dispatch, _getState, context) => context.lookup<BroadcastService>(BroadcastServiceSymbol))
}
export function setBroadcastService(value: BroadcastService) {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(BroadcastServiceSymbol, value))
}
export function unsetBroadcastService() {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().unset(BroadcastServiceSymbol))
}

const BroadcastServiceSymbol = Symbol('BroadcastService')
